import { SiteComponentPlugin } from '@sierralabs/site-ui';

import { ExportButtonPlugin } from './ExportButtonPlugin';
import { QmsFileUploadButtonPlugin } from './QmsFileUploadButtonPlugin';
import { QmsTaskStatusLabelPlugin } from './QmsTaskStatusLabelPlugin';
import { SiteLineChartPlugin } from './SiteLineChartPlugin';
import { TaskFileVersionReferenceCardPlugin } from './TaskFileVersionReferenceCardPlugin';
import { TaskJiraAssignCardPlugin } from './TaskJiraAssignCardPlugin';
import { TaskTestRailAssignCardPlugin } from './TaskTestRailAssignCardPlugin';

export const defaultQmsSitePlugins: SiteComponentPlugin<any>[] = [
  ExportButtonPlugin,
  QmsFileUploadButtonPlugin,
  QmsTaskStatusLabelPlugin,
  SiteLineChartPlugin,
  TaskFileVersionReferenceCardPlugin,
  TaskJiraAssignCardPlugin,
  TaskTestRailAssignCardPlugin
];
